import type { SessionExpiredStateTree, SessionExpiredTrigger } from './types';

export const getIsSessionExpired = (state: SessionExpiredStateTree): boolean => state.sessionExpiry?.isSessionExpired ?? false;

export const getSessionExpiredTrigger = (state: SessionExpiredStateTree): SessionExpiredTrigger | undefined =>
    state.sessionExpiry?.trigger;
